/** Input types that open the keyboard when focused. */
const KEYBOARD_INPUT_TYPES = new Set(['text', 'search', 'email', 'url', 'tel', 'password', 'number'])

/**
 * Tests whether an element is a text field that opens the keyboard when focused.
 * @param {Element | null} element Element to test, usually the focused element.
 * @returns {element is HTMLElement} Whether the element is a keyboard field.
 */
export function isKeyboardField(element: Element | null): element is HTMLElement {
  return (
    element instanceof HTMLTextAreaElement ||
    (element instanceof HTMLInputElement && KEYBOARD_INPUT_TYPES.has(element.type)) ||
    (element instanceof HTMLElement && element.isContentEditable)
  )
}
